const recommendation = [
  {
    name: 'Yris',
    project: 'Magalu',
    messageKey: 'recommendation.messages.yris',
    social: ''
  },
  {
    name: 'Fabio Almendra Martinez',
    project: 'Magalu',
    messageKey: 'recommendation.messages.fabio',
    social: ''
  },
  {
    name: 'Jéssica Andrade Zaparolli',
    project: 'Afya',
    messageKey: 'recommendation.messages.jessica',
    social: ''
  },
  {
    name: 'Bruna Honda Vargas',
    project: 'NTTData - AbInBev',
    messageKey: 'recommendation.messages.bruna',
    social: ''
  },
  {
    name: 'Murilo',
    project: 'Afya',
    messageKey: 'recommendation.messages.murilo',
    social: ''
  },
  {
    name: 'Weslley Quadros',
    project: 'NTTData - AbInBev',
    messageKey: 'recommendation.messages.weslley',
    social: ''
  }
];

export default recommendation;